import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';
import {MatCardModule} from '@angular/material/card';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {AlertModule} from '@components/alert/alert.module';
import {MatSelectModule} from '@angular/material/select';
import {MatSliderModule} from '@angular/material/slider';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {AccountComponent} from './account/account.component';
import {SettingsComponent} from './settings/settings.component';
import {LoginComponent} from './login/login.component';
import {RegisterComponent} from './register/register.component';
import {PlanComponent} from './plan/plan.component';
import {NewPasswordComponent} from './new-password/new-password.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {AffiliationComponent} from './affiliation/affiliation.component';
import {FormDeletePlanComponent} from './form-delete-plan/form-delete-plan.component';
import {PipeModule} from '~/app/shared/pipe/pipe.module';
import {PlanProComponent} from './plan-pro/plan-pro.component';
import {JoyrideModule} from 'ngx-joyride';
import { Code2authComponent } from './popup/code2auth/code2auth.component';
import {MatDialogModule} from '@angular/material/dialog';
import { RetryComponent } from './popup/retry/retry.component';
import { PlanSuccessComponent } from './popup/plan-success/plan-success.component';
import { PlanErrorComponent } from './popup/plan-error/plan-error.component';
import { PlanChangeComponent } from './popup/plan-change/plan-change.component';
import { DeleteUserComponent } from './popup/delete-user/delete-user.component';
import { ScheduleSuccessComponent } from './popup/schedule-success/schedule-success.component';

export const UserRoutes: Routes = [
    {path: '', redirectTo: 'settings', pathMatch: 'prefix'},
    {path: 'pricing', redirectTo: 'plan', pathMatch: 'prefix'},
    {path: 'settings', component: SettingsComponent},
    {path: 'account', component: AccountComponent},
    {path: 'plan', component: PlanComponent},
    {path: 'plan/:plan', component: PlanComponent},
    {path: 'plan-pro', component: PlanProComponent},
    {path: 'plan-pro/:plan', component: PlanProComponent},
    {path: 'form_delete_plan', component: FormDeletePlanComponent},
];

@NgModule({
    declarations: [LoginComponent, RegisterComponent, AccountComponent, SettingsComponent, PlanComponent, NewPasswordComponent, AffiliationComponent, FormDeletePlanComponent, PlanProComponent, Code2authComponent, RetryComponent, PlanSuccessComponent, PlanErrorComponent, PlanChangeComponent, DeleteUserComponent, ScheduleSuccessComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forChild(UserRoutes),
        MatCardModule,
        MatFormFieldModule,
        MatButtonModule,
        MatInputModule,
        MatIconModule,
        AlertModule,
        MatSelectModule,
        MatSliderModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        MatProgressSpinnerModule,
        PipeModule,
        JoyrideModule,
        MatDialogModule,
    ]
})
export class UsersModule {
}
